var cart_timeout, add_to_cart_timeout;
jQuery(document).ready(function($) {

    $(".product-image-gallery button.slick-arrow").on("click", function() {
        var index = Number($(this).parent().data("index")) || 0;
        var ul = $(this).parent().find("ul.selected-gallery");
        var newIndex;
        if ($(this).hasClass("slick-prev") && index > 1) {
             newIndex = index - 1;
            if (newIndex <= 0 ) {
                newIndex = ul.children().length;
            }
            ul.animate({scrollLeft: $(this).parent().find("ul.selected-gallery li:nth-child("+newIndex+")").position().left}, 500);
            $(this).parent().data("index", newIndex);

        } else if ($(this).hasClass("slick-next")) {
             newIndex = index+1;
           
            
            if (newIndex > ul.children().length-1) {
                newIndex = 1;
            }
            
            ul.animate({scrollLeft: $(this).parent().find("ul.selected-gallery li:nth-child("+newIndex+")").position().left}, 500);
            $(this).parent().data("index", newIndex);
        }
       
    });

    function copyAllInformationIfChecked() {
        if ($("#copy-all-information-checkbox-copyall-copy-all-information").is(":checked")) {
            var values = [];
            $("form#eerikkila-woocommerce-custom-form .accordion-item").each(function(index) {
                $(this).find(".address-field").each(function(i) {
                    if (index === 0) {
                        values[$(this).data("group")] = $(this).val();
                    } else { 
                        if ($(this).val() === "") 
                            $(this).val(values[$(this).data("group")]);
                    }
                });
            });
        }
    }

    function validateParticipantsForm(page) {
        copyAllInformationIfChecked();
        $('#eerikkila-woocommerce-custom-form').foundation('validateForm');
         var invalid = $(page === undefined ? "input[data-invalid]" : ".product.is-active input[data-invalid]");
        if (invalid.length > 0) {
            $.each(invalid, function() {
                $(this).closest(".accordion").foundation('down',  $(this).closest(".accordion-content"));
            });
            $('html, body').animate({
                scrollTop: ($(invalid[0]).offset().top - 200)
            },100);
            return false;
        }
        // if we get past the validation, destroy abide and reinitialize it. This removes error labels and on other panes.
        $('#eerikkila-woocommerce-custom-form').foundation('_destroy');
        Foundation.reInit($("[data-abide]"));       
        return true;
    }

    function updateParticipants()
    {
        var data = new FormData($("#eerikkila-woocommerce-custom-form")[0]);
        
        $.ajax({
            type : "POST",
            dataType : "json",
            processData:false,
            contentType: false,
            url : woocommerce_params.ajax_url,
            data : data,
            success: function(response) {
            }
        });   
    } 

    $("#copy-all-information-checkbox-copyall-copy-all-information").on("change", function() {
        copyAllInformationIfChecked();
    }); 

    $("#payer-select-payer_list").on("change", function() {
        var data = JSON.parse($(this).children("option:selected").val());
        if ($(this).hasClass("no-label")) {
            $(this).parent().append("<label>"+$(this).children(":first-child").text()+"</label>");
            $(this).removeClass("no-label");
        }
        var form = $(this).closest("form");
        for(var i in data) {
            form.find('input[name="payer-'+i+'"]').val(data[i]);
        } 
        
    })

    $("#eerikkila-woocommerce-custom-form").on("submit", function(e) {   
       
        return validateParticipantsForm();
    })
    $('#eerikkila-woocommerce-custom-form .product[data-index=0] input').first().focus().select();

    $("#eerikkila-woocommerce-custom-form nav .button[type='button']").on("click", function() {
        
        var current = Number($("#eerikkila-woocommerce-custom-form").attr("data-current-index"));
        
        var index = Math.min(current + Number($(this).hasClass("forward") ? 1 : -1), $("#eerikkila-woocommerce-custom-form").length);
        
        if ($(this).hasClass("forward")) {
            if (!validateParticipantsForm(current)) {
                $('#eerikkila-woocommerce-custom-form').foundation('removeErrorClasses', $('#eerikkila-woocommerce-custom-form').find("input, textarea, select"));
                return false;
            }
            updateParticipants();
        }
        $("#eerikkila-woocommerce-custom-form").attr("data-current-index", index);
        $('#eerikkila-woocommerce-custom-form .product').removeClass("is-active");
        $('#eerikkila-woocommerce-custom-form .product[data-index='+index+']').addClass("is-active");
        $('#eerikkila-woocommerce-custom-form .product[data-index='+index+'] input').first().focus();
        $("#eerikkila-woocommerce-custom-form nav .button").addClass("hidden");
        $("#eerikkila-woocommerce-custom-form nav .button" + (index === 0 ? ".cart" : ".back")).removeClass("hidden");
        $("#eerikkila-woocommerce-custom-form nav .button" + (current === $("#eerikkila-woocommerce-custom-form").length-1 ? ".checkout" : ".forward")).removeClass("hidden");
        $('html, body').animate({
            scrollTop: 0
        },100);
       
    });
    $(document).on('on.zf.toggler', function(e){
        $("body").addClass("add-to-cart-bar-open")
        $(e.target.closest(".add-to-cart-bar .content")).addClass("open");
    });
    $(document).on('off.zf.toggler', function(e){
        $("body").removeClass("add-to-cart-bar-open")
        $(e.target.closest(".add-to-cart-bar .content")).removeClass("open");
 
    });
    $(".close-bar .close").on("click", function(e) {
        $('#variable-products').foundation('toggle');
    });
    $(".close-bar .reset").on("click", function(e) {
        $("#variable-products form")[0].reset();
        $('button.remove[data-target]').attr("disabled", true);
    });
    $( document.body ).on( 'updated_cart_totals', function(){
        $(document).foundation();
    });
    $(".add-to-cart-bar #variable-products").on("click", function(e) {
        // disables toggler from closing when #variable-products is clicked
        e.stopPropagation();
    });
    $("#variable-products").on("reset", function () {
        $('button.remove[data-target]').attr("disabled", true);
    })
  
    $("#coupon_code").on("focusout", function() {
        $("button[name='apply_coupon']").trigger("click");
    })
    $(document).on("change", ".add-to-cart-bar #variable-products input, form.woocommerce-cart-form input.qty", function(e) {
        var target = $(this).attr("name");
        $('button.remove[data-target="'+target+'"]').attr("disabled", Number($(this).val()) === 0);
        if ($(this).parent().parent().hasClass("add-new")) {
            callAddToCart(true);
        } else {
            updateCart();
        }
    })

    $(".add-to-cart-bar #variable-products button").on("click", function(e) {
        var target =  $(this).data("target");
        
        if($(this).hasClass("add")) {
            updateVariableProducts(target, 1)
            $('button.remove[data-target="'+target+'"]').attr("disabled", false)
        }
        if($(this).hasClass("remove")) {
            updateVariableProducts(target, -1)
            $(this).attr("disabled", Number($('input[name="'+target+'"]').val()) === 0)
        }
        updateShoppingCartIcon();
    });

    $(document).on("click", ".woocommerce-cart-form .count button", function(e) {
        var target = $(this).parent().hasClass("add-new") ? $(this).data("target") : 'cart['+$(this).data("target")+'][qty]';
        
        if($(this).hasClass("add")) {
            updateVariableProducts(target, 1);
            $('button.remove[data-target="'+$(this).data("target")+'"]').attr("disabled", false)
        }
        if($(this).hasClass("remove")) {
            updateVariableProducts(target, -1)
            $(this).attr("disabled", Number($('input[name="'+target+'"]').val()) === 0)
        }
        if ($(this).parent().hasClass("add-new")) {
            
            if ( add_to_cart_timeout !== undefined ) {
                clearTimeout( add_to_cart_timeout );
            }
     
            add_to_cart_timeout = setTimeout(function() {
                callAddToCart();
                }, 500);
        } else {
            updateCart();
        }
    });

    function callAddToCart(reload) {
        if (reload === undefined)
            reload = false;
        var products = selectedVariableProducts();
            var add_to_cart = [];
            for (var i=0; i<products.length; i++) {
                if (!products[i].id) {
                    add_to_cart.push(products[i].name + ":"+ products[i].value);
                }               
            }

        $('input[name="add-to-cart"]').remove();
        $('.woocommerce-cart-form').addClass("processing")
        $.post("/cart/", {"add-to-cart":add_to_cart.join(","), "dont-return":1}, function() {
            $('.woocommerce-cart-form').removeClass("processing")
            if (reload) {
                window.location.reload();
            } else {
                updateCart();
            }
            //
            
        }); 
    }
   
    $(".add-to-cart-bar #variable-products form").on("submit", function(e) {
        var add_to_cart = [];
        
        var products = selectedVariableProducts();
        for (var i=0; i<products.length; i++) {
            
            if (!products[i].id) {
                add_to_cart.push(products[i].name + ":"+ products[i].value);
            }   
            
        }
        if (add_to_cart) {
            $(this).append("<input type='hidden' name='add-to-cart' value='"+add_to_cart.join(",")+"' />");
            return true;
        }
        return false;
        
    });

    function emptyCart(remove) {
        remove.val(0);
        updateCart(); 
    }

    $(document).on("click", ".cart .remove-product", function(e) {
        e.preventDefault();
        var closest = $(this).closest(".woocommerce-cart-form__cart-item");
        confirm(closest, 'Haluatko varmasti poistaa tämän tuotteen?', function() {
            emptyCart(closest.find("input.qty"));
        } ); 
    })

    $(".add-to-cart-bar .submit-cart, .add-to-cart-bar #variable-products .save-variable-product").on("click", function(e) {
        // check if there is some items in variable products. Submit cart.
        console.log("selectedVariableProducts", selectedVariableProducts())
        if (selectedVariableProducts()) {
            $(".add-to-cart-bar #variable-products form").submit()
        }
    });

    $('.woocommerce').on('change', 'input.qty', function(){
 
		updateCart()
 
    });

    function resizeDialog(target, dialog) {
        dialog.css("height", target.height());
        dialog.css("width", target.width());
    }

    function confirm(target, message, callback) {

        var removeDialog = $('<div class="remove-product-dialog" id="remove-dialog"> <div class="info"> <p class="lead">'+message+'</p> <div class="buttons"> <button type="button" class="button cancel">Peruuta</button> <button type="button" class="button yes" data-close>Poista</button></div>  </div>  </div>');
                       
		$(target).before(removeDialog);
        
        $(window).on("resize", function () {
            resizeDialog(target, removeDialog);
        })
        resizeDialog(target, removeDialog);
        removeDialog.find(".cancel").on("click", function(e) {
            e.stopPropagation()
            removeDialog.remove();
        })
        removeDialog.find(".yes").on("click", function(e) {
            e.stopPropagation()
            removeDialog.remove();
            callback.call();
        })

	}

    
    function updateCartAction(timeout)
    {
        if ( cart_timeout !== undefined ) {
			clearTimeout( cart_timeout );
		}
 
		cart_timeout = setTimeout(function() {
            // This updates the cart by triggering click on hidden woocommerce updateCart button.
            $("[name='update_cart']").trigger("click");

            // Now we count how many products there are in cart and then we update the cart button count on header.
            var count = 0;
            $(".woocommerce-cart-form input.qty").each(function() {
                count += Number($(this).val());
            })
            $(".shopping-cart-link .count").text(count > 0 ? count : "")
		}, timeout ); 
    }    
 
    function updateCart(timeout) {
        if (timeout === undefined)  
            timeout = 500;
        if ($("[name='update_cart']")) {
            $("[name='update_cart']").removeAttr("disabled");
            updateCartAction(timeout);
        }
    }

    function updateVariableProducts(target, count) {
        var _target = $('input[name="'+target+'"]');
        _target.val(Number(_target.val())+count);
    }

    function selectedVariableProducts() {
        return $(".add-to-cart-bar #variable-products input, .woocommerce-cart-form input.qty").filter(function() {
            return $(this).val() > 0
        })
 
    }

    function updateShoppingCartIcon() {
        if (selectedVariableProducts()) {
            $("button.submit-cart").addClass("has-items")
        } else {
            $("button.submit-cart").removeClass("has-items")
        }
    }
});